/* eslint-disable @typescript-eslint/no-unused-vars */
import { initializeApp } from "firebase/app";
import { getRemoteConfig } from "firebase/remote-config";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};
const app = initializeApp(firebaseConfig);
export const remoteConfig = getRemoteConfig(app);

// Default is 12 hours (43200000ms)
if (process.env.NODE_ENV === "production") {
  remoteConfig.settings.minimumFetchIntervalMillis = 2 * 60 * 60 * 1000; // 2 hours
} else {
  remoteConfig.settings.minimumFetchIntervalMillis = 10 * 60 * 1000; // 10 minutes
}
